import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { FormInputProps } from "../form-input";
import { FormItemLabel } from "./form-item-label";

export type CheckboxInputProps = Omit<FormInputProps, "formLayout">;

export const CheckboxInput: React.FC<CheckboxInputProps> = ({
  formItem,
  formData,
  setValue,
}) => {
  const resolvedValue = (): boolean => {
    const e = formData[formItem.name];
    if (!e) return false;
    else return e as boolean;
  };
  return (
    <div className="_checkbox-input.tsx checkbox-input">
      <FormControlLabel
        control={
          <Checkbox
            id={formItem.name}
            checked={resolvedValue()}
            onChange={(evt) => setValue(evt.target.checked)}
            disabled={formItem.disabled}
          />
        }
        label={
          <FormItemLabel
            label={formItem.label ?? formItem.name}
            helpText={formItem.helpText}
          />
        }
      />
    </div>
  );
};
